import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27fe96e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "consumables-assets-operator" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_4 = { class: "mb-15" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("耗材领用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登记入库")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 登记入库 ", -1))
const _hoisted_8 = { class: "d-flex mt-20" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_11 = { class: "d-flex mt-20" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_14 = { class: "d-flex mt-20" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_17 = { class: "d-flex mt-20" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_21 = { class: "d-flex mt-20" }
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确 定 ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 耗材领用 ", -1))
const _hoisted_26 = { class: "d-flex mt-20" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_28 = { class: "d-flex mt-20" }
const _hoisted_29 = { class: "mb-10" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("添加 ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_32 = { class: "d-flex justify-content--center" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("确 定 ")

import {reactive, ref, watch} from "vue";
import {ElMessage} from "element-plus";
import ConsumablesAssetListDialog from "@/views/ViewsComponents/officeAssets/ConsumablesAssetListDialog.vue";
import Api from "@/http/modules";
import {action_ly, action_rk,unitArr,office_asset_currency_list} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";


export default /*#__PURE__*/_defineComponent({
  props: {
    registerApi: null,
    orgList: null,
    companyList: null,
    categoryList: null,
    usersListApi: null,
    callback: null
  },
  emits: ['dialogShow','search'],
  setup(__props: any, { emit }) {

const props = __props as {
  registerApi: (param: any) => Promise<any>,
  orgList: any[],
  companyList: any[],
  categoryList: any[],
  usersListApi: (param: any) => Promise<any>,
  callback: (obj: { command: string, data: any }) => any
}

const {

  "POST/office/asset/ly_consumable_assets": lyConsumableAssetApi
} = Api


emit("dialogShow")
const registerDialogInfo = reactive({
  isShow: false,
  loading: false,
})
const showRegisterDialog = () => {
  queryUser("")
  setTimeout(()=>{
    registerFormRef.value.resetFields()
  },50)
  registerDialogInfo.isShow = true
}
const registerFormRef = ref()

const registerForm = reactive<{
  orgId?: number | null,
  companyId?: number | null,
  name?: string | null,
  categoryNo?: string | null,
  unit?: string | null,
  count?: number | null,
  managerId?: number | null,
  note?: string | null,
  purchasingUserId?: string | null,
  purchasingPrice?: number | null,
  purchasingCurrency?: string | null,
  purchasingDate?: string | null,
}>(
    {
      orgId: null,
      companyId: null,
      name: null,
      categoryNo: null,
      managerId: null,
      note: null,
      purchasingUserId: null,
      purchasingPrice: null,
      purchasingCurrency: "CNY",
      purchasingDate: null,
      count: null
    })

const getRealRegisterObj = () => {
  return {
    orgId: registerForm.orgId,
    companyId: registerForm.companyId,
    name: registerForm.name,
    categoryNo: registerForm.categoryNo,
    managerId: registerForm.managerId,
    count: registerForm.count,
    extra: {
      note: registerForm.note,
      unit: registerForm.unit,
      purchasingInfo: {
        userId: registerForm.purchasingUserId,
        price: registerForm.purchasingPrice,
        date: registerForm.purchasingDate,
        currency: registerForm.purchasingCurrency,
      },
    },
  }
}

const registerAsset = () => {
  registerFormRef.value.validate((valid: boolean) => {
    if (valid) {
      if (registerDialogInfo.loading) return false;
      registerDialogInfo.loading = true
      props.registerApi(getRealRegisterObj()).then((r: any) => {
        registerDialogInfo.loading = false
        registerDialogInfo.isShow = false
        ElMessage.success("登记入库成功")
        props.callback({command:action_rk,data:null})
      }).catch((e: any) => {
        ElMessage.error("登记入库失败：" + e)
        registerDialogInfo.loading = false
      })
    } else {
      return false;
    }
  })
}

const userInfo = reactive({
  userList: [],
  loading: false,
  key: null
})
const queryUser = (key?: string) => {
  if (key == userInfo.key) {
    return
  }
  userInfo.loading = true
  props.usersListApi({page: 1, size: 100, query: key}).then((r: any) => {
    userInfo.loading = false
    userInfo.userList = r.data.map((i: any) => {
      return {
        userId: i.userId,
        label: i.realName + "(" + i.alias + ")"
      }
    })
  }).catch((e: any) => {
    userInfo.loading = false
  })
}
const checkCount = (rule: any, value: any, cb: any) => {
  if (!value) {
    cb("请输入数量")
  } else {
    if (parseInt(value) < 1) {
      cb("数量最小为1")
    } else {
      cb()
    }
  }
}


const lyForm = reactive<{
  userId: null | number,
  date: null | string,
  note: null | string,
}>({
  userId: null,
  date: null,
  note: null,
})

const consumablesAssetListDialogInfo = reactive<{
  isShow: boolean,
  list: any[],
}>({
  isShow: false,
  list: []
})
const showConsumablesAssetListDialog = () => {
  consumablesAssetListDialogInfo.isShow = false
  setTimeout(() => {
    consumablesAssetListDialogInfo.isShow = true
  }, 10)
  emit("dialogShow")
}

const lyConsumablesDialogInfo = reactive<{
  isShow: boolean,
  loading: boolean,
}>({
  isShow: false,
  loading: false,
})
const showLyConsumablesDialog = () => {
  lyForm.userId = null
  lyForm.date = null
  lyForm.note = null
  consumablesAssetListDialogInfo.list = []
  queryUser("")
  lyConsumablesDialogInfo.isShow = true
}
const deleteBindAsset = (asset: any) => {
  consumablesAssetListDialogInfo.list = consumablesAssetListDialogInfo.list.filter(i => i.id != asset.id)
}
const onLyListChange = (list: any) => {
  const temp = consumablesAssetListDialogInfo.list;
  console.log("temp",list)
  for (let i = 0; i < list.length; i++) {
    if (temp.filter(item => item.id === list[i].id).length < 1) {
      temp.push({
        ...list[i],
        useCount: "1"
      })
    }
  }
  consumablesAssetListDialogInfo.list = temp
}
const lyFormRef= ref()
const lyConsumableAsset = () => {
  lyFormRef.value.validate((valid: boolean) => {
    if (!valid || lyConsumablesDialogInfo.loading) return

    console.log("consumablesAssetListDialogInfo.list",consumablesAssetListDialogInfo.list)
    if (consumablesAssetListDialogInfo.list.filter(i => !i.useCount || i.useCount.length < 1||parseInt(i.useCount,10)<1).length>0) {
      ElMessage.warning("每个耗材都需要输入大于0领用数量")
      return
    }
    if (consumablesAssetListDialogInfo.list.filter(i => {
      return parseInt(i.useCount, 10) > i.count
    }).length>0) {
      ElMessage.warning("每个耗材领用都数量不能大于其剩余数量")
      return;
    }
    lyConsumablesDialogInfo.loading = true
    const items = consumablesAssetListDialogInfo.list.map(i => {
      return {
        id: i.id,
        count: parseInt(i.useCount, 10)
      }
    })
    lyConsumableAssetApi({
      ...lyForm,
      items: items
    }).then((r: any) => {
      lyConsumablesDialogInfo.loading = false
      lyConsumablesDialogInfo.isShow=false
      ElMessage.success("耗材领用成功")
      props.callback({command:action_ly,data:null})
    }).catch((e: any) => {
      lyConsumablesDialogInfo.loading = false
      ElMessage.success("耗材领用失败：" + e)
    })
  })

}
//
watch(() => registerDialogInfo.isShow, (cur, old) => {
  if (cur) {
    emit("dialogShow")

  }
})
const searchEle=ref()
const searchObj = reactive<{
  orgId: null | number,
  companyId: null | number,
  date:string[],
}>({
  orgId: null,
  companyId: null,
  date:[]
})
const search=()=>{
  emit("search",{orgId:searchObj.orgId,companyId:searchObj.companyId,date:searchObj.date})
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_collapse, { class: "mb-15" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse_item, {
            title: "搜索",
            name: "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                class: "searchContent searchBg",
                model: _unref(searchObj),
                "label-width": "90px",
                inline: true,
                ref_key: "searchEle",
                ref: searchEle,
                "label-position": "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "所属团队:",
                    prop: "orgId",
                    class: "flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).orgId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                        placeholder: "所属团队",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "所属公司:",
                    prop: "companyId",
                    class: "flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).companyId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                        placeholder: "所属公司",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              label: group.label,
                              key: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "变动日期:",
                    prop: "date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        type: "monthrange",
                        "range-separator": "至",
                        "value-format": "YYYY-MM-DD",
                        "popper-options": { modifiers: [{
            name: 'flip',
            options: {
                fallbackPlacements: ['bottom'],
                allowedAutoPlacements: ['bottom'],
            }
        }]},
                        modelValue: _unref(searchObj).date,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).date) = $event)),
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: search
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {searchEle.value.resetFields();})
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: showLyConsumablesDialog
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          class: "ml-20",
          onClick: showRegisterDialog
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "registerConsumablesDialog",
      modelValue: _unref(registerDialogInfo).isShow,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(registerDialogInfo).isShow) = $event)),
      draggable: "",
      width: "960px"
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(registerDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: registerAsset,
            loading: _unref(registerDialogInfo).loading,
            disabled: _unref(registerDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "registerForm",
          ref_key: "registerFormRef",
          ref: registerFormRef,
          model: _unref(registerForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                label: "所属团队",
                prop: "orgId",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择所属团队'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).orgId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(registerForm).orgId) = $event)),
                    placeholder: "所属团队"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_el_form_item, {
                label: "所属公司",
                prop: "companyId",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择所属公司'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).companyId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(registerForm).companyId) = $event)),
                    placeholder: "所属公司"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                        return (_openBlock(), _createBlock(_component_el_option_group, {
                          label: group.label,
                          key: group.label
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_10,
              _createVNode(_component_el_form_item, {
                label: "耗材名称",
                prop: "name",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请输入耗材名称'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(registerForm).name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(registerForm).name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, {
                label: "耗材类别",
                prop: "categoryNo",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择耗材类别'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).categoryNo,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(registerForm).categoryNo) = $event)),
                    placeholder: "耗材类别"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.no
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_12,
              _createVNode(_component_el_form_item, {
                label: "单位",
                prop: "unit",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请输入单位'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).unit,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(registerForm).unit) = $event)),
                    placeholder: "单位"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unitArr), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_13,
              _createVNode(_component_el_form_item, {
                label: "总数量",
                prop: "count",
                class: "flex-1",
                rules: [{required:true,message:'请输入数量'},{ validator: checkCount, trigger: 'blur',message: '数量最小为1' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(registerForm).count,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(registerForm).count) = $event)),
                    oninput: "value=value.replace(/[^\\d]/g,'')"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_form_item, {
                prop: "managerId",
                label: "管理员",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择管理员'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).managerId,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(registerForm).managerId) = $event)),
                    placeholder: "请输入关键字",
                    remote: "",
                    filterable: "",
                    clearable: "",
                    "remote-method": queryUser,
                    loading: _unref(userInfo).loading,
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading"])
                ]),
                _: 1
              }),
              _hoisted_15,
              _createVNode(_component_el_form_item, {
                label: "采购日期",
                prop: "purchasingDate",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择采购日期'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(registerForm).purchasingDate,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(registerForm).purchasingDate) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD",
                    placeholder: "采购日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_16,
              _createVNode(_component_el_form_item, {
                prop: "purchasingUserId",
                label: "采购人",
                required: "",
                class: "flex-1",
                rules: [{required:true,message:'请选择采购人'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).purchasingUserId,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(registerForm).purchasingUserId) = $event)),
                    placeholder: "请输入关键字",
                    remote: "",
                    filterable: "",
                    clearable: "",
                    "remote-method": queryUser,
                    loading: _unref(userInfo).loading,
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form_item, {
                prop: "purchasingCurrency",
                label: "币种",
                required: "",
                class: "flex-1",
                rules: [{required:true,message:'请选择币种'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(registerForm).purchasingCurrency,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(registerForm).purchasingCurrency) = $event)),
                    placeholder: "请选择币种"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(office_asset_currency_list), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.value,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_18,
              _createVNode(_component_el_form_item, {
                label: "采购价格",
                prop: "purchasingPrice",
                class: "flex-1",
                rules: [{required:true,message:'请输入采购价格'}],
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(registerForm).purchasingPrice,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(registerForm).purchasingPrice) = $event)),
                    class: "price-input",
                    oninput: "value=value.replace(/[^\\d]/g,'')"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_19,
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_form_item, {
                label: "备注",
                prop: "note",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(registerForm).note,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(registerForm).note) = $event)),
                    type: "textarea",
                    autosize: { minRows: 3},
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "lyConsumablesDialog",
      modelValue: _unref(lyConsumablesDialogInfo).isShow,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(lyConsumablesDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _hoisted_25
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(lyConsumablesDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: lyConsumableAsset,
            loading: _unref(lyConsumablesDialogInfo).loading,
            disabled: _unref(lyConsumablesDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "lyForm pl-20",
          ref_key: "lyFormRef",
          ref: lyFormRef,
          model: _unref(lyForm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_form_item, {
                label: "领用人",
                prop: "userId",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择领用人'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(lyForm).userId,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(lyForm).userId) = $event)),
                    placeholder: "请输入关键字",
                    remote: "",
                    filterable: "",
                    clearable: "",
                    "remote-method": queryUser,
                    loading: _unref(userInfo).loading,
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userInfo).userList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.label,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading"])
                ]),
                _: 1
              }),
              _hoisted_27,
              _createVNode(_component_el_form_item, {
                label: "领用日期",
                prop: "date",
                class: "flex-1",
                required: "",
                rules: [{required:true,message:'请选择领用日期'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(lyForm).date,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(lyForm).date) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "date",
                    placeholder: "领用日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_form_item, {
                label: "备注",
                prop: "note",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(lyForm).note,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(lyForm).note) = $event)),
                    type: "textarea",
                    autosize: { minRows: 3},
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (showConsumablesAssetListDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              })
            ]),
            _hoisted_31,
            _createVNode(_component_el_table, {
              border: "",
              class: "mt-10",
              data: _unref(consumablesAssetListDialogInfo).list,
              "row-key": "id",
              "max-height": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属团队",
                  prop: "orgName",
                  width: "140",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "所属公司",
                  prop: "companyName",
                  width: "140",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "耗材编号",
                  prop: "no",
                  width: "235",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "耗材名称",
                  prop: "name",
                  width: "140",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "耗材类别",
                  prop: "categoryName",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "单位",
                  prop: "unit",
                  width: "60",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "剩余数量",
                  prop: "count",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "领用数量",
                  width: "100",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_input, {
                      modelValue: row.useCount,
                      "onUpdate:modelValue": ($event: any) => ((row.useCount) = $event),
                      oninput: "value=value.replace(/[^\\d]/g,'')"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "70"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (deleteBindAsset(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ConsumablesAssetListDialog, {
      show: _unref(consumablesAssetListDialogInfo).isShow,
      "category-list": __props.categoryList,
      "org-list": __props.orgList,
      "company-list": __props.companyList,
      onSelect: onLyListChange
    }, null, 8, ["show", "category-list", "org-list", "company-list"])
  ]))
}
}

})